import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate";
// * IMPORT MODULES
import upload_file_store from "@/modules/file-upload/upload_file_store.js";
import alertbox_store from "@/modules/alertbox/alertbox_store.js";
import confirmation_store from '@/modules/confirmation/confirmation_store.js';
import datePicker_store from '@/modules/datePicker/datePicker_store.js';
import comment_store from '@/modules/comment/comment_store.js';
import location_store from '@/modules/location/location_store.js';
import fsDialog_store from '@/modules/fsDialog/fsDialog_store.js';
import puDialog_store from '@/modules/puDialog/puDialog_store.js';
import photoUpload_store from '@/modules/photoUpload/photoUpload_store.js';
import photoViewer_store from '@/modules/photoViewer/photoViewer_store.js';
import confirmBox_store from '@/modules/confirmBox/confirmBox_store.js';
import docViewer_store from '@/modules/docViewer/docViewer_store.js';
import docUpload_store from '@/modules/docUpload/docUpload_store.js';
import fireSelected_store from '@/modules/fireSelected/fireSelected_store.js';

import progressBar_store from '@/modules/progressBar/progressBar_store.js';

//qr code
import qr_code_reader_store from '@/modules/qr-code-reader/qr_code_reader_store.js';
import qr_code_generator_store from '@/modules/qr-code-generator/qr_code_generator_store.js';

// Firebase Authentication Service
import firebase_auth_store from '@/modules/firebase/firebase_auth_store.js';

// //auth stores
// import tfw_email from '@/components/auth/tfw-employee/email-address/tfw_email_store.js';
// import main_register_store from '@/views/auth/main_register_store.js';
// import tfw_contact_details from '@/components/auth/tfw-employee/contact-details/tfw_contact_details_store.js'
// import contractor_company_details from "@/components/auth/contractor/company/company_details_store.js";
// import contractor_contact_details from "@/components/auth/contractor/contact-details/contractor_contact_details_store.js";
// import visitor_company_details from "@/components/auth/visitor/company/visitor_company_details_store.js";
// import visitor_contact_details from "@/components/auth/visitor/contact-details/visitor_contact_details_store.js";

// * EXPORT VUEX
export default new Vuex.Store({
    // * MODULES
    modules: {
        upload_file_store: upload_file_store,
        alertbox_store: alertbox_store,
        confirmation_store: confirmation_store,
        datePicker_store: datePicker_store,
        comment_store: comment_store,
        confirmBox_store: confirmBox_store,
        docViewer_store: docViewer_store,
        docUpload_store: docUpload_store,
        location_store: location_store,
        fsDialog_store: fsDialog_store,
        fireSelected_store: fireSelected_store,
        puDialog_store: puDialog_store,
        photoUpload_store: photoUpload_store,
        photoViewer_store: photoViewer_store,
        qr_code_reader_store: qr_code_reader_store,
        qr_code_generator_store: qr_code_generator_store,
        progressBar_store: progressBar_store,
        firebase_auth_store: firebase_auth_store,
        // tfw_email: tfw_email,
        // main_register_store: main_register_store,
        // tfw_contact_details: tfw_contact_details,
        // contractor_company_details: contractor_company_details,
        // contractor_contact_details: contractor_contact_details,
        // visitor_company_details: visitor_company_details,
        // visitor_contact_details: visitor_contact_details
    },
    // * PLUGINS
    plugins: [createPersistedState()],
    // * STATE
    state: {

        // page: {
        //     title: '',
        //     subtitle: '',
        //     breadcrumbs: '',  
        // },
        breadcrumbs: [],  // breadcrumbs for page header
        pageTitle: '',
        pageRoute: '',
        dialogPane: {
            show: false,
        },
        panelLayout: {
            leftPanel: 12,
            rightPanel: 0,
            show: false,
            title: '',
            dynamicComponent: ''
        },
        // DOCUMENTS STATE
        openDocument: {},
        // PROJECTS STATE
        openProject: {}, // Used to Store openProject details
        projects: [], // Used to Store projects
        // CONCERN STATE
        openConcern: {}, // Used to Store openConcern details
        // NOTICE STATE
        openNotice: {}, // Used to Store openNotice details
        openNotification: {}, // Used to Store openNotice details
        openGuide: {},
        // FIRE ROLL CALL STATE
        openFireRollCall: {}, // Used to Store openFireRollCall details
        // Pass STATE
        openPass: {}, // Used to Store openPass details
        // Access STATE
        openAccess: {}, // Used to Store openAccess details

        // FILE STATE
        openFile: {}, // Used to Store openFile details
        // USER STATE
        openUser: {}, // Used to Store openUser details
        // ORGANISATION STATE
        openOrganisation: {},
        organisations: [], // Stores organisations for dropdowns
        //SlIDES STATE
        openSlide:{},
        slides:[],
        //QUESTIONS STATE
        openQuestion:{},
        questions:[],
        // SITE STATE
        openSite: {},
        sites: [],
        //curr user
        currentUser: null,

        //organisation state
        openOrganisation: {},
        // LOOKUPS STATE
        lookupTables: [],
        lookupValues: [],

        // CONTRACTOR MANAGER / ADMIN USERS STATE
        usersMA: [],
        // Hosts
        usersHosts: [], // User Hosts are of userType STAFF and userRole MANAGER OR ADMIN
        allUsersHosts: [], // User Hosts are userRole MANAGER OR ADMIN

        // Show Helpful Notes
        help: true,

        mobileNav: false,

        simulatedUserRole: '',
        simulatedUserType: '',

    },
    // * GETTERS
    getters: {

        GET_mobileNav(state) { return state.mobileNav }, // GET MOBILE NAV

        // USER DETAILS
        GET_currentUser(state) { 
            var currentUser = state.currentUser;
            // console.log('curr user: ' + JSON.stringify(state.currentUser, null, 2))
            // if(currentUser !== null && currentUser !== undefined){
            //     if(currentUser.userRole != undefined && currentUser.userType != undefined) {
            //         if ((state.simulatedUserRole !== '') && (state.simulatedUserRole !== undefined)) { currentUser.userRole = state.simulatedUserRole; }
            //         if ((state.simulatedUserType !== '') && (state.simulatedUserType !== undefined)) { currentUser.userType = state.simulatedUserType; }
            //         currentUser.userLevel = currentUser.userType.substring(0,1) + currentUser.userRole.substring(0,1);  
            //     }
                
            // }
        //    console.log('currentUser.userType = ' + JSON.stringify(currentUser, null, 2))
            if (currentUser !== null) {
                currentUser.userLevel = currentUser.userType.substring(0,1) + currentUser.userRole.substring(0,1);  
                // console.log("userLevel = " + currentUser.userLevel)
            }
            return currentUser
        },
          
		GET_appUpdate(state) { return state.appUpdate }, // appUpdate getters
        // USER DATA
        GET_currentUserData(state) { return {
            userId: state.currentUser.id,
            userName: state.currentUser.userName,
            userEmail: state.currentUser.userEmail,
            organisationId: state.currentUser.organisation.organisationId,
            organisationName: state.currentUser.organisation.organisationName,
        }},

        GET_help(state) { return state.help },
        // SITE GETTERS
        GET_openSite(state) { return state.openSite },
        GET_sites(state) { return state.sites }, // GET sites
        GET_openGuide(state) { return state.openGuide },
        // PROJECT GETTERS
        GET_openProject(state) { return state.openProject },
        GET_projects(state) { return state.projects },
        // CONCERN GETTERS
        GET_openConcern(state) { return state.openConcern },
        // NOTICE GETTERS
        GET_openNotice(state) { return state.openNotice },
        GET_openNotification(state) { return state.openNotification },
        // FIRE ROLL CALL GETTERS
        GET_openFireRollCall(state) { return state.openFireRollCall },
        // PASS GETTERS
        GET_openPass(state) { return state.openPass },
        // ACCESS GETTERS
        GET_openAccess(state) { return state.openAccess },

        // FILE GETTERS
        GET_openFile(state) { return state.openFile },
        // DOCUMENT GETTERS
        GET_openDocument(state) { return state.openDocument },
        // ORGANISATION GETTERS
        GET_openOrganisation(state) { return state.openOrganisation },
        GET_organisations(state) { return state.organisations }, // GET organisations
        // USER GETTERS
        GET_openUser(state) { return state.openUser },
        GET_openOrganisation(state) { return state.openOrganisation },
        //Slides Getter
        GET_openSlide(state) {return state.openSlide},
        GET_slides(state) { return state.slides }, // GET organisations

        //Questions Getter
        GET_openQuestion(state) {return state.openQuestion},
        GET_questions(state) { return state.questions }, // GET organisations

        GET_breadcrumbs(state) { return state.breadcrumbs },
        // PANEL LAYOUT GETTERS
        GET_panelLayout(state) { return state.panelLayout },

        // LOOKUPS GETTERS
        GET_lookupValues: (state) => (lookupTable) => { 
            return state.lookupValues.filter((lookupValue) => {
                return lookupValue.lookupTable === lookupTable
            }) 
        },

        // CONTRACTOR MANAGER / ADMIN USERS GETTERS
        GET_usersMA(state) { return state.usersMA },
        GET_usersHosts(state) { return state.usersHosts }, // User Hosts are of userType STAFF and userRole MANAGER OR ADMIN
        GET_allUsersHosts(state) { return state.allUsersHosts }, // User Hosts are of userType STAFF and userRole MANAGER OR ADMIN
    },
    // * MUTATIONS
    mutations: { 
		MUT_appUpdate(state, payload) { state.appUpdate =  payload }, // appUpdate mutation
        MUT_simulatedUserType(state, data) { state.simulatedUserType = data }, // SET MOBILE NAV
        MUT_simulatedUserRole(state, data) { state.simulatedUserRole = data }, // SET MOBILE NAV

        MUT_currentUser(state, payload) {
            state.currentUser = payload;
        },

        MUT_mobileNav(state, data) { state.mobileNav = data }, // SET MOBILE NAV

        MUT_help(state, data) { state.help = data },
        // BREADCRUMBS
        MUT_breadcrumbs(state, data) { state.breadcrumbs = data },
        // SITE MUTATIONS
        MUT_openSite(state, data) { state.openSite = data },
        MUT_sites(state, data) { state.sites = data }, // Mutates sites state
        // PROJECT MUTATIONS
        MUT_openProject(state, data) { state.openProject = data },
        MUT_projects(state, data) { state.projects = data },
        // CONCERN MUTATIONS
        MUT_openConcern(state, data) { state.openConcern = data },
        // NOTIFICATION MUTATIONS
        MUT_openNotification(state, data) { state.openNotification = data },

        // NOTICE MUTATIONS
        MUT_openNotice(state, data) { state.openNotice = data },
        MUT_openGuide(state, data) { state.openGuide = data },
        // CONCERN MUTATIONS
        MUT_openFireRollCall(state, data) { state.openFireRollCall = data },
        // PASS MUTATIONS
        MUT_openPass(state, data) { state.openPass = data },
        // PASS MUTATIONS
        MUT_openAccess(state, data) { state.openAccess = data },

        // FILE MUTATIONS
        MUT_openFile(state, data) { state.openFile = data },
        // DOCUMENT MUTATIONS
        MUT_openDocument(state, data) { state.openDocument = data },     
        // ORGANISATOIN MUTATIONS
        MUT_openOrganisation(state, data) { state.openOrganisation = data }, // Mutates openOrganisation state
        MUT_organisations(state, data) { state.organisations = data }, // Mutates organisations state

        // SLIDES MUTATION
        MUT_openSlide(state,data) {state.openSlide = data}, // Mutates openSlide state
        MUT_slides(state, data) { state.slides = data }, // Mutates slides state

        // Question MUTATION
        MUT_openQuestion(state,data) {state.openQuestion = data}, // Mutates openquestions state
        MUT_questions(state, data) { state.questions = data }, // Mutates questions state
        // USER MUTATIONS
        MUT_openUser(state, data) { state.openUser = data },

        // PANEL LAYOUT MUTATIONS
        MUT_panelLayout(state, data){ state.panelLayout = data },

        // LOOKUP TABLES MUTATIONS
        MUT_lookupTables (state, data) { state.lookupTables = data },
        MUT_lookupValues (state, data) { state.lookupValues = data },

        set_Page(state, payload) { state.page = payload },
        update_openDocument(state, payload) { state.openDocument = payload },
        set_dialogPane(state, payload) { state.dialogPane = payload },
        setPageTitle(state, payload) { state.pageTitle = payload },
        setPageRoute(state, payload) { state.pageRoute = payload },

        // CONTRACTOR MANAGER / ADMIN USERS MUTATIONS
        MUT_usersMA(state, data){ state.usersMA = data },
        MUT_usersHosts(state, data){ state.usersHosts = data }, // User Hosts are of userType STAFF and userRole MANAGER OR ADMIN
        MUT_allUsersHosts(state, data){ state.allUsersHosts = data }, // User Hosts are of userType STAFF and userRole MANAGER OR ADMIN


    },
    // * ACTIONS    
    actions: {
		ACT_alertBox({commit}, payload) { commit('MUT_alertBox', payload) }, // alertBox action        
        ACT_currentUser({commit}, payload) { commit('MUT_currentUser', payload) },

        ACT_simulatedUserType({commit}, payload) { commit('MUT_simulatedUserType', payload) },
        ACT_simulatedUserRole({commit}, payload) { commit('MUT_simulatedUserRole', payload) },

        ACT_mobileNav({commit}, payload) { commit('MUT_mobileNav', payload) }, // SET MOBILE NAV


        // HELP
        ACT_help({commit}, payload) { commit('MUT_help', payload) },
        // BREADCRUMBS
        ACT_breadcrumbs({commit}, payload) { commit('MUT_breadcrumbs', payload) },
        // LAYOUT PANEL ACTIONS
        ACT_panelLayout({commit}, payload){ commit('MUT_panelLayout', payload) },
        // SITES ACTIONS
        ACT_openSite({commit}, payload){ commit('MUT_openSite', payload) },
        ACT_sites({commit}, payload){ commit('MUT_sites', payload) },
        // PROJECT ACTIONS
        ACT_openProject({commit}, payload){ commit('MUT_openProject', payload) },
        ACT_projects({commit}, payload){ commit('MUT_projects', payload) },
        // CONCERN ACTIONS
        ACT_openConcern({commit}, payload){ commit('MUT_openConcern', payload) },
        ACT_openGuide({commit}, payload){ commit('MUT_openGuide', payload) },
        // NOTIFICATION ACTIONS
        ACT_openNotification({commit}, payload){ commit('MUT_openNotification', payload) },
        // FIRE ROLL CALL ACTIONS
        ACT_openFireRollCall({commit}, payload){ commit('MUT_openFireRollCall', payload) },

        // NOTICE ACTIONS
        ACT_openNotice({commit}, payload){ commit('MUT_openNotice', payload) },
        // PASS ACTIONS
        ACT_openPass({commit}, payload){ commit('MUT_openPass', payload) },
        // ACCESS ACTIONS
        ACT_openAccess({commit}, payload){ commit('MUT_openAccess', payload) },
        // FILE ACTIONS
        ACT_openFile({commit}, payload){ commit('MUT_openFile', payload) },

        // DOCUMENT ACTIONS
        ACT_openDocument({commit}, payload){ commit('MUT_openDocument', payload) },
        // ORGANISATION ACTIONS
        ACT_openOrganisation({commit}, payload){ commit('MUT_openOrganisation', payload) },
        ACT_organisations({commit}, payload){ commit('MUT_organisations', payload) },
        // SLIDES ACTIONS
        ACT_openSlide({commit}, payload){ commit('MUT_openSlide', payload) },
        ACT_slides({commit}, payload){ commit('MUT_slides', payload) },

        // QUESTIONS ACTIONS
        ACT_openQuestion({commit}, payload){ commit('MUT_openQuestion', payload) },
        ACT_questions({commit}, payload){ commit('MUT_questions', payload) },

        // USER ACTIONS
        ACT_openUser({commit}, payload){ commit('MUT_openUser', payload) },
        // // ORGANISATION ACTIONS
        // ACT_openOrganisation({commit}, payload){ commit('MUT_openOrganisation', payload) },
        // LOOKUP TABLES ACTIONS
        ACT_lookupTables({commit}, payload) { commit('MUT_lookupTables', payload) },
        ACT_lookupValues({commit}, payload) { commit('MUT_lookupValues', payload) },

        // CONTRACTOR MANAGERS / ADMIN USERS ACTIONS
        ACT_usersMA({commit}, payload) {  commit('MUT_usersMA', payload) },
        ACT_usersHosts({commit}, payload) {  commit('MUT_usersHosts', payload) },
        ACT_allUsersHosts({commit}, payload) {  commit('MUT_allUsersHosts', payload) },

    }
})
